import { formControlLabelClasses, FormControlLabelProps } from '@mui/material';
import { Theme } from '@mui/material/styles';

export default function FormControlLabel(theme: Theme) {
  const rootStyles = (ownerState: FormControlLabelProps) => {
    const labelPlacementStart = ownerState.labelPlacement === 'start';
    const labelPlacementTop = ownerState.labelPlacement === 'top';
    const labelPlacementBottom = ownerState.labelPlacement === 'bottom';
    const labelPlacementEnd =
      !ownerState.labelPlacement || ownerState.labelPlacement === 'end';

    const defaultStyle = {
      margin: 0,
      display: 'inline-flex',
      alignItems: 'center',
      cursor: 'pointer',
      verticalAlign: 'middle',
      WebkitTapHighlightColor: 'transparent',

      [`& > .${formControlLabelClasses.label}`]: {
        fontSize: theme.typography.body3.fontSize,
      },
    };

    const placementStyles = {
      ...(labelPlacementStart && {
        flexDirection: 'row-reverse',
      }),
      ...(labelPlacementTop && {
        flexDirection: 'column-reverse',
        marginLeft: 0,
        marginRight: 0,
      }),
      ...(labelPlacementBottom && {
        flexDirection: 'column',
        marginLeft: 0,
        marginRight: 0,
      }),
      ...(labelPlacementEnd && {
        flexDirection: 'row',
      }),
    };

    const disabledStyles = {
      ...(ownerState.disabled && {
        cursor: 'default',
        color: theme.palette.text.disabled,
      }),
    };

    return {
      ...defaultStyle,
      ...placementStyles,
      ...disabledStyles,
    };
  };

  const labelStyles = (ownerState: FormControlLabelProps) => {
    const labelPlacementStart = ownerState.labelPlacement === 'start';
    const labelPlacementTop = ownerState.labelPlacement === 'top';
    const labelPlacementBottom = ownerState.labelPlacement === 'bottom';

    const defaultLabelStyle = {
      ...theme.typography.body2,
      color: theme.palette.text.primary,
    };

    const placementStyles = {
      ...(labelPlacementStart && {
        paddingRight: theme.spacing(1),
      }),
      ...(labelPlacementTop && {
        paddingBottom: theme.spacing(0.5),
      }),
      ...(labelPlacementBottom && {
        paddingTop: theme.spacing(0.5),
      }),
      ...(!labelPlacementStart &&
        !labelPlacementTop &&
        !labelPlacementBottom && {
          paddingLeft: theme.spacing(1),
        }),
    };

    const disabledStyles = {
      ...(ownerState.disabled && {
        color: theme.palette.text.disabled,
      }),
    };

    return {
      ...defaultLabelStyle,
      ...placementStyles,
      ...disabledStyles,
    };
  };

  return {
    MuiFormControlLabel: {
      styleOverrides: {
        root: ({ ownerState }: { ownerState: FormControlLabelProps }) =>
          rootStyles(ownerState),
        label: ({ ownerState }: { ownerState: FormControlLabelProps }) =>
          labelStyles(ownerState),
      },
    },
  };
}
